import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  margin: 103px 16px auto 16px;
  border-radius: 8px;
  background: #ecedf7;
  padding: 16px;
`;

export const ModalTitle = styled.div`
  color: #111;
  text-align: center;
  font-family: 'GmarketSansBold';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */
  letter-spacing: -0.5px;
  margin-bottom: 12px;
`;

export const ModalContent = styled.div`
  display: flex;
  width: 274px;
  flex-direction: column;

  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 2px;
    height: 400px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background: #0b2873;
  }
`;

export const NoticeTitle = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.35px;
`;

export const Notice = styled.ul`
  color: #333;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.3px;
  padding: 0 29px 16px 16px;
  list-style-type: disc;
`;

export const Summary = styled.div`
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.35px;
  text-align: center;
  margin-bottom: 10px;
`;

export const CloseButton = styled.button`
  width: 274px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #0b2873;
  color: #fff;
`;

export const ConfirmButton = styled.button`
  margin-top: 16px;
  width: 274px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #0b2873;
  color: #fff;
`;

export const AskMethod = styled.div`
  color: #777;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  margin-bottom: 10px;
`;
